import React, { FC } from 'react';

import { EvSection, EvSpinner } from '@evinced-private/ui-common';

import { GeneralError } from 'src/common/components/errors/general-error/GeneralError';

import { BusinessUnit } from '../../types/DashboardTypes';

interface BusinessUnitLoadingStatesProps {
	isConfigLoading: boolean;
	businessUnits: BusinessUnit[];
	unitId: string | undefined;
}

export const BusinessUnitLoadingStates: FC<BusinessUnitLoadingStatesProps> = ({
	isConfigLoading,
	businessUnits,
	unitId
}) => {
	// Show loading if configuration is still loading
	if (isConfigLoading) {
		return (
			<EvSection className="dashboard-business-units-loading">
				<div className="dashboard-business-units-loading-wrapper">
					<EvSpinner />
				</div>
			</EvSection>
		);
	}

	// Show error if no business units found in configuration
	if (!isConfigLoading && businessUnits.length === 0) {
		return (
			<GeneralError title="Configuration Error" displayContactInfo={false}>
				<p>No business units found in configuration.</p>
				<p>Please check your platform configuration for unitId labels.</p>
			</GeneralError>
		);
	}

	// Show loading if we don't have a unitId and haven't redirected yet
	if (!unitId) {
		return (
			<EvSection className="dashboard-business-units-redirecting">
				<div className="dashboard-business-units-redirecting-wrapper">
					<EvSpinner />
				</div>
			</EvSection>
		);
	}

	// If we get here, we should render the main content
	return null;
};
